// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__30QYH","header":"styles_header__3Ty6W"};